const types = [
  { id: 'store', labelId: 'Store' },
  { id: 'building', labelId: 'Building' },
  { id: 'apartment', labelId: 'Apartment' },
  { id: 'room', labelId: 'Room' },
  { id: 'office', labelId: 'Office' },
  { id: 'garage', labelId: 'Garage' },
  { id: 'parking', labelId: 'Parking spot' },
  { id: 'letterbox', labelId: 'Mailbox' },
];

export default types;
